import * as types from '../../../constants/actionTypes'
import { request } from '../../../helpers/apiHelper'
import { displayNotification } from '../../../actions/notificationsActions'
import { uploadDocumentMutation } from '../queries'

export const uploadingDocument = () => ({
  type: types.UploadingDocument,
})

export const uploadingDocumentSuccess = () => ({
  type: types.UploadingDocumentSuccess,
})

export const uploadingDocumentFailure = () => ({
  type: types.UploadingDocumentFailure,
})

export const uploadDocument = (document) => (dispatch) => {
  dispatch(uploadingDocument())
  return request(uploadDocumentMutation.default, { image: document })
    .then((res) => {
      if (res.data.errors) {
        throw new Error(res.data.errors[0].message)
      } else {
        dispatch(uploadingDocumentSuccess())
        dispatch(displayNotification('Upload Document Successful'))
        return res
      }
    })
    .catch((error) => {
      dispatch(uploadingDocumentFailure())
      dispatch(displayNotification('Upload Document Failed', 'error', 30000))
      throw error
    })
}
